import { IApplicationContext } from 'shared/types/applicationContext';
import { TApplicationState, TReduxStore } from 'shared/types/redux';
import { createReduxStore } from 'shared/utils/redux';

export function createApplicationState(context: IApplicationContext): TReduxStore {
  const { config } = context;

  const initialState = config.getStrict<TApplicationState>('initialState');

  return createReduxStore(context, initialState, true);
}
